import { render, staticRenderFns } from "./goodsTranslateLst.vue?vue&type=template&id=c0417692&scoped=true&"
import script from "./goodsTranslateLst.vue?vue&type=script&lang=js&"
export * from "./goodsTranslateLst.vue?vue&type=script&lang=js&"
import style0 from "./goodsTranslateLst.vue?vue&type=style&index=0&id=c0417692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0417692",
  null
  
)

export default component.exports